var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7389 49.3051C31.7725 49.3051 30.1691 47.7018 30.1691 45.7353V34.6176C30.1691 33.9596 29.6321 33.4226 28.9741 33.4226H19.4446C18.7866 33.4226 18.2496 33.9596 18.2496 34.6176V45.7353C18.2496 47.7018 16.6462 49.3051 14.6798 49.3051H9.51423C7.11673 49.3051 5.18814 47.4144 5.14276 45.0849V26.8427H3.17635C1.84524 26.8427 0.695647 26.0637 0.211608 24.8612C-0.249742 23.6964 0.0603454 22.3426 0.975482 21.4956L22.0009 1.73316C22.5984 1.17349 23.385 0.863403 24.2094 0.863403C25.0337 0.863403 25.8127 1.17349 26.4178 1.73316L47.4508 21.488C48.3811 22.3502 48.676 23.6662 48.2147 24.846C47.7306 26.0561 46.581 26.8351 45.2802 26.8351H43.2835V45.0698C43.2381 47.4068 41.302 49.2976 38.9801 49.2976H33.7464L33.7389 49.3051ZM7.12429 22.8721C8.22094 22.8721 9.10583 23.7645 9.10583 24.8536V45.0698C9.12852 45.1984 9.27978 45.3345 9.46129 45.3345H14.2941V34.61C14.2941 31.7663 16.6084 29.452 19.4522 29.452H28.9817C31.8254 29.452 34.1397 31.7663 34.1397 34.61V45.3345H38.9196C39.1541 45.3345 39.3053 45.1984 39.328 45.0244V24.8536C39.328 23.7569 40.2129 22.8721 41.3096 22.8721H43.1398L24.2094 5.10631L5.29402 22.8721H7.12429Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHome);
export default __webpack_public_path__ + "static/media/menu-home.87a0aa98eee96faeb375964d80b85075.svg";
export { ForwardRef as ReactComponent };